import React, { useState, useEffect } from "react";

const hdrs = () => ({ "Content-Type": "application/json", Authorization: "Bearer " + sessionStorage.getItem("mise_token") });
const C = { card: "#fff", border: "#e8e2d8", text: "#2c1810", sub: "#8b7355", accent: "#e8593c", greenDark: "#27500a" };
const inp = { width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid " + C.border, fontSize: 14, fontFamily: "'DM Sans',sans-serif", boxSizing: "border-box", outline: "none" };
const lbl = { fontSize: 12, fontWeight: 600, color: C.sub, display: "block", marginBottom: 6 };
const moeda = (v) => {
  const d = String(v ?? "").replace(/\D/g, "");
  return (parseInt(d || "0", 10) / 100).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
const moedaParaNumero = (v) => parseFloat(String(v).replace(/\./g, "").replace(",", ".")) || 0;

const ConfigTab = () => {
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch("/api/tenant", { headers: hdrs() }).then(r => r.json()).then(t => setForm({
      name: t.name || "", phone: t.phone || "", whatsapp: t.whatsapp || "",
      logo_url: t.logo_url || "", address: t.address || "", city: t.city || "",
      delivery_fee: moeda(String(t.delivery_fee || "0").replace(/\D/g, "").padStart(3, "0")), min_order_value: moeda(String(t.min_order_value || "0").replace(/\D/g, "").padStart(3, "0")),
      estimated_delivery_min: t.estimated_delivery_min || 40
    }));
  }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const salvar = async () => {
    setSaving(true); setMsg("");
    const body = { ...form,
      whatsapp: form.whatsapp.replace(/\D/g, "") || null,
      phone: form.phone.replace(/\D/g, "") || null,
      delivery_fee: moedaParaNumero(form.delivery_fee),
      min_order_value: moedaParaNumero(form.min_order_value),
      estimated_delivery_min: parseInt(String(form.estimated_delivery_min).replace(/\D/g, "")) || 40
    };
    const res = await fetch("/api/tenant", { method: "PUT", headers: hdrs(), body: JSON.stringify(body) });
    setMsg(res.ok ? "OK Configuracoes salvas!" : "ERRO ao salvar");
    setSaving(false);
    setTimeout(() => setMsg(""), 3000);
  };

  if (!form) return <div style={{ padding: 24, color: C.sub }}>Carregando...</div>;

  return (
    <div style={{ padding: 24, maxWidth: 640 }}>
      <div style={{ fontSize: 20, fontWeight: 700, color: C.text, marginBottom: 4 }}>Configuracoes do Restaurante</div>
      <div style={{ fontSize: 13, color: C.sub, marginBottom: 20 }}>Dados usados no cardapio online e nos pedidos por WhatsApp</div>

      <div style={{ background: C.card, border: "1px solid " + C.border, borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.text, marginBottom: 14 }}>Identidade</div>
        <div style={{ marginBottom: 14 }}><label style={lbl}>Nome do restaurante</label><input style={inp} value={form.name} onChange={e => set("name", e.target.value)} /></div>
        <div style={{ marginBottom: 14 }}><label style={lbl}>Logo (URL da imagem - aparece no cartao do WhatsApp)</label><input style={inp} value={form.logo_url} onChange={e => set("logo_url", e.target.value)} placeholder="https://..." /></div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div><label style={lbl}>Endereco</label><input style={inp} value={form.address} onChange={e => set("address", e.target.value)} /></div>
          <div><label style={lbl}>Cidade</label><input style={inp} value={form.city} onChange={e => set("city", e.target.value)} /></div>
        </div>
      </div>

      <div style={{ background: C.card, border: "1px solid " + C.border, borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.text, marginBottom: 4 }}>WhatsApp de pedidos</div>
        <div style={{ fontSize: 12, color: C.sub, marginBottom: 14 }}>Numero que recebe os pedidos do cardapio online (o numero atendido pela IA). Formato: 55 + DDD + numero</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div><label style={lbl}>WhatsApp de pedidos</label><input style={inp} value={form.whatsapp} onChange={e => set("whatsapp", e.target.value)} placeholder="5511987654321" /></div>
          <div><label style={lbl}>Telefone fixo (opcional)</label><input style={inp} value={form.phone} onChange={e => set("phone", e.target.value)} /></div>
        </div>
      </div>

      <div style={{ background: C.card, border: "1px solid " + C.border, borderRadius: 12, padding: 20, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.text, marginBottom: 14 }}>Entrega</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
          <div><label style={lbl}>Taxa de entrega (R$)</label><input style={inp} type="text" inputMode="decimal" value={form.delivery_fee} onChange={e => set("delivery_fee", moeda(e.target.value))} placeholder="5,00" /></div>
          <div><label style={lbl}>Pedido minimo (R$)</label><input style={inp} type="text" inputMode="decimal" value={form.min_order_value} onChange={e => set("min_order_value", moeda(e.target.value))} placeholder="0,00" /></div>
          <div><label style={lbl}>Tempo estimado (min)</label><input style={inp} type="text" inputMode="numeric" value={form.estimated_delivery_min} onChange={e => set("estimated_delivery_min", e.target.value)} placeholder="40" /></div>
        </div>
      </div>

      <button onClick={salvar} disabled={saving}
        style={{ padding: "13px 32px", borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: "pointer", border: "none", background: C.accent, color: "#fff" }}>
        {saving ? "Salvando..." : "Salvar configuracoes"}
      </button>
      {msg && <span style={{ marginLeft: 14, fontSize: 14, fontWeight: 600, color: msg.startsWith("OK") ? C.greenDark : C.accent }}>{msg}</span>}
    </div>
  );
};

export default ConfigTab;
